import React, { Component } from 'react';
import { Form, Input, Label, Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class AdditionalInvestigations extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="AdditionalInvestigations">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="AdditionalInvestigations__Form"
        >
          <h1>{translate('fiche.additional_investigations.title')}</h1>

          <Label
            text={translate('fiche.additional_investigations.radiology')}
          />
          <Input name="radiology" defaultValue={data.radiology} />

          <Label
            text={translate(
              'fiche.additional_investigations.laboratory_research'
            )}
          />
          <Input
            name="laboratory_research"
            defaultValue={data.laboratory_research}
          />

          <Label text={translate('fiche.additional_investigations.others')} />
          <Input name="others" defaultValue={data.others} />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(AdditionalInvestigations);
